export default "__VITE_ASSET__d6c02beb__"